import { render, staticRenderFns } from "./Flowformlist.vue?vue&type=template&id=096b2d78&"
import script from "./Flowformlist.vue?vue&type=script&lang=js&"
export * from "./Flowformlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports